module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES78UC4']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC4']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text  width-70",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codempid) + " - " + _vm._s(_vm.detail.tab1.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text  width-70",
    attrs: {
      "id": "dtereq",
      "name": "dtereq"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtereq)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text  width-70",
    attrs: {
      "id": "codlon",
      "name": "codlon"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codlon))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC4']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.amtlonreq),
      expression: "detail.tab1.amtlonreq"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "amtlonreq",
      "name": "amtlonreq",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.detail.tab1.amtlonreq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "amtlonreq", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC5']['60']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC4']['0']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.numlonreqyr),
      expression: "detail.tab1.numlonreqyr"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numlonreqyr",
      "name": "numlonreqyr",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.detail.tab1.numlonreqyr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "numlonreqyr", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['100']))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.numlonreqmth),
      expression: "detail.tab1.numlonreqmth"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numlonreqmth",
      "name": "numlonreqmth",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.detail.tab1.numlonreqmth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "numlonreqmth", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['110']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC4']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text  width-70",
    attrs: {
      "id": "reaslon",
      "name": "reaslon"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.reaslon))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC4']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text  width-70",
    attrs: {
      "id": "qtyperiod",
      "name": "qtyperiod"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.qtyperiod))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC4']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.amttlpay),
      expression: "detail.tab1.amttlpay"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "amttlpay",
      "name": "amttlpay",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.detail.tab1.amttlpay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "amttlpay", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC5']['60']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC4']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.amtpaybo),
      expression: "detail.tab1.amtpaybo"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "amtpaybo",
      "name": "amtpaybo",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.detail.tab1.amtpaybo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "amtpaybo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC5']['60']))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES78UC4']['140']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC8']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text  width-70",
    attrs: {
      "id": "desc_codlon",
      "name": "desc_codlon"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab2.desc_codlon))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC8']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.amtmxlon),
      expression: "detail.tab2.amtmxlon"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "amtmxlon",
      "name": "amtmxlon",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.detail.tab2.amtmxlon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab2, "amtmxlon", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC5']['60']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC8']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text  width-70",
    attrs: {
      "id": "ratelon",
      "name": "ratelon"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab2.ratelon))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC8']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.nummxlonyr),
      expression: "detail.tab2.nummxlonyr"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "nummxlonyr",
      "name": "nummxlonyr",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.detail.tab2.nummxlonyr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab2, "nummxlonyr", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['100']))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.nummxlonmth),
      expression: "detail.tab2.nummxlonmth"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "nummxlonmth",
      "name": "nummxlonmth",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.detail.tab2.nummxlonmth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab2, "nummxlonmth", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['110']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC8']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text  width-70",
    attrs: {
      "id": "remark",
      "name": "remark"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab2.remark))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details3"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES78UC4']['150']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive panel-detail-filter"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC1']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text  width-70",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codempid) + " - " + _vm._s(_vm.detail.tab1.desc_codempid))])])])]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.detailTab3Table,
      "data": _vm.detail.tab3.table
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b98313b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres78u/detail.vue
// module id = 3646
// module chunks = 1